import IconDropdown from 'components/styledFormElements/IconDropdown'
import { CustomCheckoutFormValues } from 'containers/Protected/CustomCheckout/types'
import { getImageSrc, normalizeIconPath } from 'services/util'
import { X } from 'lucide-react'
import React, { useState } from 'react'
import { Control, Controller, FieldPath } from 'react-hook-form'

interface IconUploaderProps {
  control: Control<CustomCheckoutFormValues>
  name: FieldPath<CustomCheckoutFormValues>
  label?: string
  error?: string
}

const IconUploader: React.FC<IconUploaderProps> = ({
  control,
  name,
  label = 'Icon',
  error,
}) => {
  const [iconName, setIconName] = useState('')

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const iconValue = field.value as string

        return (
          <div className="flex w-full flex-col">
            <label className="mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              {label} <span className="text-red-700">*</span>
            </label>

            {iconValue ? (
              <div className="flex items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 dark:border-slate-600 dark:bg-slate-800">
                <div className="flex min-w-0 items-center gap-2">
                  <img
                    src={
                      iconValue.startsWith('http')
                        ? iconValue
                        : getImageSrc(iconValue)
                    }
                    alt="Selected icon"
                    className="h-6 w-6 shrink-0 object-contain"
                  />
                  <span className="truncate text-sm text-gray-700 dark:text-gray-200">
                    {iconName || 'Icon selected'}
                  </span>
                </div>

                <button
                  type="button"
                  onClick={() => {
                    field.onChange('')
                    setIconName('')
                  }}
                  className="ml-2 shrink-0 rounded-full bg-black/70 p-1 text-white hover:bg-black"
                  aria-label="Remove icon"
                >
                  <X size={14} />
                </button>
              </div>
            ) : (
              <IconDropdown
                value={iconValue}
                placeholder="Select icon"
                onChange={(selectedIcon) => {
                  const iconPath =
                    selectedIcon?.icon ||
                    (selectedIcon as any)?.path ||
                    (selectedIcon as any)?.image ||
                    ''

                  if (!iconPath) return

                  field.onChange(normalizeIconPath(iconPath))
                  setIconName(selectedIcon?.name || '')
                }}
              />
            )}

            {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
          </div>
        )
      }}
    />
  )
}

export default IconUploader
